import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Helmet } from 'react-helmet';
import HubNav from '../../ResourceHubPages/HubNav/HubNav';
import PressHeader from './components/PressHeader';
import PressNewsList from './components/PressNewsList';
import PageHeaders from '../../../Utils/PageHeaders';
import PartnersSection from '../Home/components/PartnersSection';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '40px',
  },
}));

const PressPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HubNav />
       <PageHeaders
          title="Plootus in the Press — Media Coverage & News Mentions"
          description="See where Plootus has been featured — EBRI, The College Investor, Experian, PlanSponsor, PlanAdviser. Learn how Plootus is changing retirement planning for millions of Americans."
          ogTitle="Plootus in the Press — Featured in Yahoo Finance, Bankrate & More"
          ogDescription="Media coverage of Plootus, the free AI-powered retirement planning platform trusted by thousands managing 401k, 403b, and 457 plans."
          ogImage="Media logo wall graphic (Yahoo Finance, Bloomberg, Forbes, Bankrate icons) — powerful trust-building visual for social sharing and journalist outreach"
          canonicalUrl="https://www.plootus.com/press"
        />
      <PressHeader />
      <PartnersSection titleDisabled={true} rootPadding="0"/>
      <PressNewsList />
    </div>
  );
};

export default PressPage;
